import { Home } from "./components/Home";
import { GetReturnsListResidentialandRural } from "./components/GetReturnsListResidentialandRural";
import { GetReturnsListNil } from "./components/GetReturnsListNil";
import { AddResidentialReturn } from "./components/AddResidentialReturn";
import { AddRuralReturn } from "./components/AddRuralReturn";
import { AddNilReturn } from "./components/AddNilReturn.js";
import { AdminReports } from "./components/AdminReports.js"

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/GetReturnsListResidentialandRural',
        element: <GetReturnsListResidentialandRural />
    },
    {
        path: '/GetReturnsListNil',
        element: <GetReturnsListNil />
    },
    {
        path: '/AddResidentialReturn',
        element: <AddResidentialReturn />
    },
    {
        path: '/AddRuralReturn',
        element: <AddRuralReturn />
    },
    {
        path: '/AddNilReturn',
        element: <AddNilReturn />
    },
    {
        path: '/AdminReports',
        element: <AdminReports />
    }


];

export default AppRoutes;
